export enum CampaignListColumns {
    ACTIVATION_TYPE = "activationType",
    URL_ID = "urlId",
    URL_MEDIUM_NAME = "urlMediumName",
    USED = "used",
    COPY_URLS = "copyCampaignUrls",
    CREATED_DATE = "createdDate",
    OPTIONS = "options"
}